
	import mixins from "vue-typed-mixins";
	import Session from "@/shared/mixins/Session";
	import Profile from "@/shared/mixins/Profile";
	import Language from "@/shared/mixins/Language";
	const MIXINS = [Session, Profile, Language];
	const Vue = mixins(...MIXINS);

  export default Vue.extend({
		mixins: MIXINS,
		data() {
			return {
				/**
				 *  Number that represents the current view selected.
				 */
				selectedTab: 0 as number,
				/**
				 *  Used when loading the role of the user.
				 */
				loading: false,
				/**
				 * Knows when a user is already logged in.
				 **/
				loggedIn: false,

				/**
				 * Used to hide and show the navigation drawer.
				 **/
				drawer: false,
				languages: [
					{
						id: 1,
						locale: "en",
						text: "English",
					},
					{
						id: 2,
						locale: "es",
						text: "Español",
					},
					{
						id: 3,
						locale: "ja",
						text: "日本語",
					},
				],
				currentLanguage: this.getLocale || "es",
			};
		},
		mounted(): void {
			this.currentLanguage = this.getLocale;
			this.changeLocale();

      this.selectedTab = this.items.findIndex(
				(ele) => ele.route === this.$router.currentRoute.fullPath
			);

			if (this.selectedTab == -1) {
				this.selectedTab = this.items.findIndex((ele) => ele.route === "/forms");
			}
		},
		methods: {
			/**
			 *
			 * Changes rendered route
			 * @param i Index on routes array
			 * @param route text of the route
			 * @public
			 *
			 */
			selectTab(i: number, route: string) {
				this.selectedTab = i;
				if (this.$route.path !== route) {
					this.$router.push(route).catch((err) => {
						console.log(err);
					});
				}
			},
			/**
			 *
			 * Restricts view depending on the role of the user.
			 * @param rolesAllowed List of roles allowed on a route
			 * @returns {boolean} returns true if the user has permission to access this view.
			 * @public
			 */
			// restrictViews(rolesAllowed: Array<string>) {
			// 	return true;
			// },
			doLogout() {
				this.loading = true;
				this.logout();
			},
			changeLocale() {
				if (this.currentLanguage) {
					this.setLocale(this.currentLanguage);
					this.$i18n.locale = this.currentLanguage;
				}
			},
      getInitials(name: string) {
        const initials = name.replace(/[^a-zA-Z- ]/g, "").match(/\b\w/g);

        return initials?.join('').toUpperCase();
      }
		},
    computed: {
      profile: {
        get() {
          return {
            name: this.profileName,
            email: this.profileEmail
          }
        }
      },
      items: {
        set() {
          return [];
        },
        get() {
          let navigation = [
            {
              icon: "mdi-clipboard-list-outline",
              text: this.$t("navigation.route.forms"),
              route: "/forms",
              roleRestrict: [],
            },
            {
              icon: "mdi-account-group",
              text: this.$t("navigation.route.users"),
              route: "/users",
              roleRestrict: ["admin"],
            },
            {
              icon: "mdi-text-box-check-outline",
              text: this.$t("navigation.route.repliesLog"),
              route: "/repliesLog",
              roleRestrict: ["admin"],
            },
          ];
          return navigation.filter(item => {
            return item.roleRestrict.length == 0 ||
                item.roleRestrict.includes(this.profileRole)});
        },
      },
    },
	});
